var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGig(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.1666 24.9168V17.2502C42.1666 7.66683 38.3333 3.8335 28.7499 3.8335H17.2499C7.66659 3.8335 3.83325 7.66683 3.83325 17.2502V28.7502C3.83325 38.3335 7.66659 42.1668 17.2499 42.1668H24.9166",
    stroke: "#00CFC5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0491 27.7726L18.6107 21.85C19.2624 21.0067 20.4699 20.8534 21.3133 21.5051L24.8208 24.2651C25.6641 24.9167 26.8716 24.7634 27.5232 23.9392L31.9508 18.2275",
    stroke: "#00CFC5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3367 30.3218L37.8733 31.4142C38.1417 31.9509 38.8125 32.4493 39.4067 32.5643L40.135 32.6793C42.32 33.0434 42.8375 34.6534 41.2658 36.2443L40.595 36.9151C40.1541 37.3751 39.905 38.2567 40.0392 38.8701L40.135 39.2726C40.7292 41.9176 39.33 42.9334 37.03 41.5534L36.5317 41.2659C35.9375 40.9209 34.9792 40.9209 34.385 41.2659L33.8866 41.5534C31.5675 42.9526 30.1683 41.9176 30.7817 39.2726L30.8775 38.8701C31.0116 38.2567 30.7625 37.3751 30.3217 36.9151L29.6508 36.2443C28.0792 34.6534 28.5967 33.0434 30.7817 32.6793L31.51 32.5643C32.085 32.4684 32.775 31.9509 33.0433 31.4142L33.58 30.3218C34.615 28.2326 36.3017 28.2326 37.3367 30.3218Z",
    stroke: "#00CFC5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGig);
export default __webpack_public_path__ + "static/media/gig.859f4230054cdb2a13b46002b2f822db.svg";
export { ForwardRef as ReactComponent };